// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Float from "../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as StringUtils from "../../../rnr/utils/StringUtils.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";

function getButtonClickPayload(msisdn, button_title, timestamp) {
  return {
          payload: "Driver with msisdn: " + msisdn + " clicked on " + button_title + " at " + timestamp
        };
}

function getCurrentTimestamp(param) {
  return String(DateTime$Catalyst.toTimeStamp(DateTime$Catalyst.now(undefined)));
}

function stringToScoreStateEnum(score_state) {
  switch (score_state) {
    case "LOCKED" :
        return /* LOCKED */1;
    case "UNLOCKED" :
        return /* UNLOCKED */0;
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "PartnerScoreHelper.res",
              17,
              2
            ],
            Error: new Error()
          };
  }
}

function enumToScoreStateString(score_state) {
  switch (score_state) {
    case /* UNLOCKED */0 :
        return "UNLOCKED";
    case /* LOCKED */1 :
        return "LOCKED";
    case /* DEFAULT */2 :
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "PartnerScoreHelper.res",
                24,
                2
              ],
              Error: new Error()
            };
    
  }
}

function stringToScoreTypeEnum(score_type) {
  switch (score_type) {
    case "CANCELLATION_SCORE" :
        return /* CANCELLATION_SCORE */1;
    case "COMPLETION_SCORE" :
        return /* COMPLETION_SCORE */0;
    default:
      return /* DEFAULT */2;
  }
}

function enumToScoreTypeString(score_type) {
  switch (score_type) {
    case /* COMPLETION_SCORE */0 :
        return "COMPLETION_SCORE";
    case /* CANCELLATION_SCORE */1 :
        return "CANCELLATION_SCORE";
    case /* DEFAULT */2 :
        return "";
    
  }
}

function isLastIndex(index, length) {
  var match = (length - index | 0) - 1 | 0;
  return match === 0;
}

function getPrevScore(index, threshold_values) {
  if (index !== 0) {
    return Belt_Option.getWithDefault(Belt_Float.fromString(StringUtils.removeSymbolsFromString(Caml_array.get(threshold_values, index - 1 | 0), ["%"])), 0);
  } else {
    return 0;
  }
}

function thresholdValueToFloat(val) {
  return Belt_Option.getWithDefault(Belt_Float.fromString(StringUtils.removeSymbolsFromString(val, ["%"])), 0);
}

function getSliderMarkingValue(val, max_score) {
  if (thresholdValueToFloat(val) === max_score) {
    return ">" + val;
  } else {
    return val;
  }
}

export {
  getButtonClickPayload ,
  getCurrentTimestamp ,
  stringToScoreStateEnum ,
  enumToScoreStateString ,
  stringToScoreTypeEnum ,
  enumToScoreTypeString ,
  isLastIndex ,
  getPrevScore ,
  thresholdValueToFloat ,
  getSliderMarkingValue ,
  
}
/* DateTime-Catalyst Not a pure module */
